






















































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
// @ts-ignore
import Password from "vue-password-strength-meter";
import ISignupUpdateModel from "@/interfaces/signup-update-model";

@Component({
  components: {
    Password,
  },
})
export default class Signup extends Vue {
  checkPassword(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("A password is required"));
    } else {
      if (this.passwordScore < 3) {
        return callback(new Error("A stronger password is required."));
      }

      return callback();
    }
  }

  passwordScore = 0;

  @Ref("firstNameInput")
  firstNameInput!: any;

  signupForm: any = {
    companyName: "",
    firstName: "",
    lastName: "",
    password: "",
    userId: "",
  };

  rules: any = {
    firstName: {
      required: true,
      message: "Your first name is required",
      trigger: ["blur"],
    },
    lastName: {
      required: true,
      message: "Your last name is required",
      trigger: ["blur"],
    },
    password: {
      required: true,
      validator: this.checkPassword,
      trigger: ["blur"],
    },
  };

  @Ref("signupFormRef")
  signupFormRef!: any;

  failed = false;
  loading = false;

  mounted() {
    if (this.$route.params && this.$route.params.userId) {
      this.signupForm.userId = this.$route.params.userId;
      this.firstNameInput.focus();
    } else {
      this.failed = true;
    }
  }

  //
  // Used for validation
  setPasswordScore(score: number) {
    this.passwordScore = score;
  }

  signup() {
    this.signupFormRef.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;

        const model: ISignupUpdateModel = {
          userId: this.signupForm.userId,
          firstName: this.signupForm.firstName,
          companyName: this.signupForm.companyName,
          lastName: this.signupForm.lastName,
          password: this.signupForm.password,
        };

        this.$store.dispatch("authentication/signupUpdate", model).then(
          () => {
            this.loading = false;
            this.signupForm.userId = "";
            this.signupForm.firstName = "";
            this.signupForm.lastName = "";
            this.signupForm.company = "";
            this.signupForm.password = "";
            //
            // Redirect the user to the login page
            this.$router.push({ name: "login" });
            //
            // Show a message
            this.$message({
              message:
                "Your account has been created successfully. Please login below.",
              type: "success",
              duration: 6000, // we want the login message to be visible twice as long as normal messages
            });
          },
          () => {
            this.loading = false;
            this.$message({
              message:
                "Something went wrong while saving your data. Please try again",
              type: "error",
            });
          }
        );
      }
    });
  }
}
